module.exports = __webpack_public_path__ + "images/product-icon.3a899057a569b4dc42d216eb6b009bea.png";